module.exports = {"title":"Tutorial","order":1,"body":"<p>In this tutorial we will build a TodoMVC app using Reindex, React and Relay.\nThe structure of the app is roughly similar to the\n<a href=\"https://github.com/facebook/relay/tree/master/examples/todo\">Relay example</a>,\nbut instead of writing a GraphQL server from scratch, we will simply use\nReindex.</p>\n<p>Source code for this tutorial is available at\n<a href=\"https://github.com/reindexio/reindex-examples/tree/master/todomvc-single-user\">GitHub</a>.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./docs/tutorial/index.md
 ** module id = 379
 ** module chunks = 0
 **/